module.exports = __webpack_public_path__ + "img/telegram.b771cc4.svg?v=1761300065174";